<template>
  <div class="flex h-[161px] w-full items-stretch overflow-clip tablet:h-[200px] laptop:h-[222px]" data-testid="jobs-board-lead">
    <div class="relative grid-container items-end overflow-clip pt-10 pb-4 tablet:items-center">
      <div class="col-span-12 col-start-1 tablet:col-span-8 tablet:col-start-3">
        <span class="relative z-10 bg-white text-headline-m-uppercase tablet:text-headline-xl-uppercase">
          <div class="rocket" />

          <span>{{ $t('jobs_board.lead.first_line') }}</span>
          <br />
          <span>{{ $t('jobs_board.lead.second_line') }}</span>
          <div class="magnifying-glass" />
        </span>
      </div>

      <div class="ufo" />
    </div>
  </div>
</template>

<style scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.rocket {
  @apply absolute z-20 bg-[url('~/assets/lead/rocket.svg')] bg-contain bg-center bg-no-repeat;
  @apply h-[80px] w-[60px] tablet:h-[170px] tablet:w-[100px] laptop:h-[200px] laptop:w-[143px];
  @apply top-[-80px] left-0 tablet:top-[-49px] tablet:left-[-113px] laptop:top-[-42px] laptop:left-[-189px] desktop:top-[-23px];
}

.magnifying-glass {
  @apply absolute z-20 bg-[url('~/assets/lead/magnifying-glass.svg')] bg-contain bg-center bg-no-repeat;
  @apply h-[90px] w-[100px] tablet:h-[127px] tablet:w-[144px] laptop:h-[141px] laptop:w-[169px];
  @apply top-[-92px] right-[-73px] tablet:top-[-92px] tablet:right-[-114px] laptop:top-[-82px] laptop:right-[-160px];
}

.ufo {
  @apply absolute bg-[url('~/assets/lead/ufo.svg')] bg-contain bg-center bg-no-repeat;
  @apply h-[150px] w-[100px] tablet:h-[270px] tablet:w-[247px];
  @apply right-0 bottom-[-68px] tablet:right-0 tablet:bottom-[-97px] laptop:right-[30px] laptop:bottom-[-115px];
}
</style>
